import React from 'react';
import { Modal } from 'react-bootstrap';
import classNames from 'classnames';

import './EditUnitBaseModal.scss';

const EditUnitBaseModal = ({
	className,
	title,
	primaryActionLabel,
	primaryActionDisabled,
	onPrimaryAction,
	secondaryActionLabel,
	onSecondaryAction,
	onHide,
	children
}) => {
	return (
		<Modal
			size="lg"
			show
			aria-labelledby="contained-modal-title-vcenter"
			centered
			className={classNames('edit-unit-base-modal', className)}
			onHide={onHide}
			backdropClassName="modal-backdrop-no-show"
		>
			<Modal.Header closeButton>
				<div className="header-content">
					<h1>{title}</h1>
				</div>
				<div className="header-close-spacer" />
			</Modal.Header>
			<Modal.Body>{children}</Modal.Body>
			<Modal.Footer>
				<button type="button" className="footer-buttons secondary-button" onClick={onSecondaryAction}>
					{secondaryActionLabel}
				</button>
				<button
					type="button"
					className="footer-buttons primary-button"
					disabled={primaryActionDisabled}
					onClick={onPrimaryAction}
				>
					{primaryActionLabel}
				</button>
			</Modal.Footer>
		</Modal>
	);
};

export default EditUnitBaseModal;
